import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { RegionOptionsMap } from '../../../lib/cart/region-options'
import { AddressRestrictions, FormValues } from '../../../lib/cart/types'
import useCountriesAndRegions from '../../../lib/m2/hooks/useCountriesAndRegions'
import usePlacesBrowser from '../../../lib/places/hooks/usePlacesBrowser'
import AddressForm, { AddressFormProps } from './AddressForm'
import AddressFormWithAutocomplete from './AddressFormWithAutocomplete'

export interface AddressFormCheckoutProps {
  addressRestrictions?: AddressRestrictions
  defaultValues?: FormValues.Address
  showEmail?: boolean
}

const defaultValuesKeys: Array<keyof FormValues.Address> = [
  'city',
  'country_code',
  'firstname',
  'lastname',
  'postcode',
  'region',
  'street1',
  'street2',
  'telephone',
]

const fieldsToWatch = defaultValuesKeys

const AddressFormCheckout: React.FC<AddressFormCheckoutProps> = ({
  addressRestrictions,
  defaultValues,
  showEmail = false,
}) => {
  const { watch } = useFormContext<FormValues.Address>()
  const fieldValues = watch(fieldsToWatch)
  const {
    countryOptions,
    error: countriesError,
    loading: countriesLoading,
    regionOptions,
  } = useCountriesAndRegions(fieldValues.country_code, addressRestrictions, true)
  const regionOptionsMap = useMemo(() => new RegionOptionsMap(regionOptions), [regionOptions])

  const { isOutdatedBrowserForAutocomplete } = usePlacesBrowser()

  const addressFormProps: AddressFormProps = {
    addressRestrictions,
    defaultValues,
    countriesLoading,
    countriesError,
    countryOptions,
    regionOptions,
    regionOptionsMap,
    showEmail,
  }

  return isOutdatedBrowserForAutocomplete ? (
    <AddressForm {...addressFormProps} />
  ) : (
    <AddressFormWithAutocomplete {...addressFormProps} />
  )
}

export default AddressFormCheckout
